import moment from "moment";

/**
 * Relative-time phrase for the autosave "Last saved …" indicator (LSP-16420).
 *
 * Returns "just now" for the first minute (moment would otherwise say "a few
 * seconds ago"), then delegates to moment for "2 minutes ago", "an hour ago",
 * "3 hours ago", etc. The indicator renders this as `Last saved {phrase}`.
 *
 * `now` is injectable so the indicator can recompute against a ticking clock
 * and tests stay deterministic.
 */
export function formatLastSaved(savedAt: number, now: number = Date.now()): string {
	const elapsedMs = now - savedAt;
	if (elapsedMs < 60_000) {
		return "just now";
	}
	return moment(savedAt).from(moment(now));
}
